module.exports = __webpack_public_path__ + "img/closed_orange.e5b121d7.svg";